import React from 'react';
import { Card } from 'antd';
import PropTypes from 'prop-types';

const WorkExpCard = ({ children, loading }) => {
  return (
    <Card className="new-mcq-work-exp-card" loading={loading}>{children}</Card>
  );
};

WorkExpCard.propTypes = {
  children: PropTypes.any,
  loading: PropTypes.bool
};

export default WorkExpCard;
